var _rect, _rect2, _rect3, _polygon, _polygon2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "411px",
    height: "571px",
    viewBox: "0 0 411 571",
    enableBackground: "new 0 0 411 571",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.2,
    fill: "#EDEDED",
    width: 411.4,
    height: 569.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 135,
    fill: "none",
    stroke: "#878787",
    strokeWidth: 1.5113,
    strokeMiterlimit: 10,
    width: 243.8,
    height: 414.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 148.4,
    fill: "none",
    stroke: "#878787",
    strokeWidth: 1.4032,
    strokeMiterlimit: 10,
    width: 219.2,
    height: 389.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6357,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 21.8,41.7 21.9,32.1 0,32.1 12.3,41.7 21.7,41.7 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6357,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 389.3,41.7 398.7,41.7 411,32.1 389.1,32.1 389.2,41.7 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M21.3,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H21.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M21.3,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M54.8,32.1v520.1H55c1.2,3.1,8.1,5.6,16.5,5.6s15.3-2.4,16.5-5.6 h0.2V32.1H54.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M54.8,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M88.3,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H88.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M88.3,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M121.8,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H121.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M121.8,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M155.3,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 c8.4,0,15.3-2.4,16.5-5.6h0.2V32.1H155.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M155.3,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M188.8,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H188.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M188.8,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M222.3,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H222.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M222.3,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M255.8,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H255.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M255.8,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M289.3,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H289.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M289.3,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M322.8,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H322.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M322.8,61.7c0,0,13.3,6.8,33.4,0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M356.3,32.1v520.1h0.2c1.2,3.1,8.1,5.6,16.5,5.6 s15.3-2.4,16.5-5.6h0.2V32.1H356.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeMiterlimit: 10,
    d: "M356.3,61.7c0,0,13.3,6.8,33.4,0"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5732,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 411,
    height: 32.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowArc);
export default __webpack_public_path__ + "static/media/window-Arc.d306eca6703da46c5f678344b231f3e2.svg";
export { ForwardRef as ReactComponent };